module.exports = __webpack_public_path__ + "img/btn_VM_scoreBoard.bad49119.svg";